module.exports = __webpack_public_path__ + "static/media/chargext-logo.86518d54.png";